module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "end-title_1"
  }, [_c('span', [_vm._v("PRAISE FOR THE WRITING OF PATRICIA POTTER")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“Patricia Potter is a master storyteller, a powerful weaver of romantic tales.” —Mary Jo Putney, "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“One of the romance genre’s finest talents.” —"), _c('i', [_vm._v("Romantic Times")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“Patricia Potter will thrill lovers of the suspense genre as well as those who enjoy a good romance.” "), _c('i', [_vm._v("—Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“Potter proves herself a gifted writer as artisan, creating a rich fabric of strong characters whose wit and intellect will enthrall even as their adventures entertain.” —"), _c('i', [_vm._v("BookPage")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“When a historical romance [gets] the Potter treatment, the story line is pure action and excitement, and the characters are wonderful.” "), _c('i', [_vm._v("—BookBrowse")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“Potter has an expert ability to invest in fully realized characters and a strong sense of place without losing momentum in the details, making this novel a pure pleasure.” —"), _c('i', [_vm._v("Publishers Weekly")]), _vm._v(", starred review of "), _c('i', [_vm._v("Beloved Warrior")])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("“[Potter] proves that she’s adept at penning both enthralling historicals and captivating contemporary novels.” "), _c('i', [_vm._v("—Booklist")]), _vm._v(", starred review of "), _c('i', [_vm._v("Dancing with a Rogue")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6438a9ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/endmatter02.vue
// module id = 63
// module chunks = 0